import SlideViewerMultipleChoiceQuestion from './questions/SlideViewerMultipleChoiceQuestion';

export function MultipleChoiceExampleAnswer({ currentSlide, isTeacher }) {
  return (
    <div className="max-w-full overflow-scroll flex flex-col flex-grow px-4 example-answer overflow-auto">
      <SlideViewerMultipleChoiceQuestion
        canSubmit={false}
        question={currentSlide.question}
        showAnswersInSidebar={isTeacher}
      />
    </div>
  );
}
